import useRateHooks from 'src/components/document-rate/rateHooks';
import useDocFeedbackHooks from 'src/components/doc-feedback/docFeedbackHooks';

const useDocHelp = () => {
    const rateHook = useRateHooks();
    const docFeedbackHook = useDocFeedbackHooks();

    return {
        rateHook,
        docFeedbackHook
    };
};

export default useDocHelp;
